import SpineWrapper from '@Core/Animation/SpineWrapper';
import { Gamble } from '../Gamble';
import { Container } from 'pixi.js';

export class GambleCard {
    static readonly CARD_SPINE_KEY: string = 'gamble_card';
    static readonly SKIN_NAME: string = 'default';

    public cardSpine: SpineWrapper;
    public cardContainer: Container;
    public cardId: number;
    public slotName: string;
    constructor(gamble: Gamble, cardId: number) {
        this.cardContainer = new Container({ parent: gamble.gambleElements });
        this.cardSpine = new SpineWrapper(
            gamble.scene,
            {
                x: 0,
                y: 0
            },
            { dataKey: GambleCard.CARD_SPINE_KEY, skinName: GambleCard.SKIN_NAME, manuallyScaleOnResize: true },
            true
        );
        this.slotName = cardId === 0 ? 'card' : `card${cardId + 1}`;

        this.cardContainer.addChild(this.cardSpine.spine);
        gamble.gambleElements.addChild(this.cardContainer);
        gamble.gambleSpine.slotManager.assignObjectToSlot(this.slotName, this.cardContainer);
    }

    public isCardHit(): boolean {
        //TODO: Migrate to PIXI
        //pointer: Input.Pointer
        // const worldPos = this.cardSpine.spine.getWorldTransformMatrix().transformPoint(0, 0);
        // const width = this.cardSpine.spine.width * this.cardSpine.spine.scaleX * this.cardSpine.spine.parentContainer.scaleX;
        // const height = this.cardSpine.spine.height * this.cardSpine.spine.scaleY * this.cardSpine.spine.parentContainer.scaleY;
        // const rect = new Geom.Rectangle(worldPos.x - width / 2, worldPos.y - height / 2, width, height);
        // const isHit = Geom.Rectangle.Contains(rect, pointer.x, pointer.y);
        return false; //!!isHit;
    }
}
